var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconList0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 19.25C5.1375 19.25 5.95833 18.4292 5.95833 17.4167C5.95833 16.4042 5.1375 15.5833 4.125 15.5833C3.11247 15.5833 2.29166 16.4042 2.29166 17.4167C2.29166 18.4292 3.11247 19.25 4.125 19.25Z",
    stroke: "#383F43",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 6.41667C5.1375 6.41667 5.95833 5.59588 5.95833 4.58333C5.95833 3.57081 5.1375 2.75 4.125 2.75C3.11247 2.75 2.29166 3.57081 2.29166 4.58333C2.29166 5.59588 3.11247 6.41667 4.125 6.41667Z",
    stroke: "#383F43",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 12.8333C5.1375 12.8333 5.95833 12.0125 5.95833 11C5.95833 9.98745 5.1375 9.16666 4.125 9.16666C3.11247 9.16666 2.29166 9.98745 2.29166 11C2.29166 12.0125 3.11247 12.8333 4.125 12.8333Z",
    stroke: "#383F43",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 11H19.7083",
    stroke: "#383F43",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 17.4167H19.7083",
    stroke: "#383F43",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 4.58334H19.7083",
    stroke: "#383F43",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList0);
export default __webpack_public_path__ + "static/media/icon-list-0.6b8ed2b5437b83f997da59ad7edfc1f1.svg";
export { ForwardRef as ReactComponent };